import React from 'react';
import services from '../../services';
import { Select } from 'antd';
import FilterInputs from './FilterInputs';
import { Button } from '@progress/kendo-react-buttons'
import { Tooltip } from '@progress/kendo-react-tooltip';
import Lang from '../../lang'
import $ from 'jquery'
import { toast } from 'react-toastify';
import { Input } from '@progress/kendo-react-inputs';

var moment = require('moment')
const { Option } = Select;



const clicksarch = () => {
  $("#searchButton").trigger('click');
}
const clearsearchfilterInputdiv = () => {
  $(".searchfilterInputdiv").val("");
}


class SearchFilter extends React.Component {

  /* Primeiro passo na acomodação da classe */

  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      filterChips: [],
      showFilter: false,
      entityList: [],
      entity_list_object: {},
      entity_options: "",
      deafault_selected_checkbox: 'Explorer',
      filterCheckbox: {},
      selectedEntity: "",
      popUpEntity: "",
      tabsComponentsView: '',
      detailPopUp: '',
      searchValid: 0,
      levantamento: '',
      leventoOption: "",
      installationOptions: '',
      boletimOptions : '',
      estatutoOptions : '',
      SelosOptions : '',
      RegistoOptions: '',
      MarcasOptions:[]
    }
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {
    this.setState({
      levantamento: '',
      filter: {},
      selectedEntity: "",
      entity_options: '',
      leventoOption: '',
      filterCheckbox: {},
      filterChips: [],
      showFilter: false
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.date && prevProps.date !== this.props.date) {
      this.setState({
        levantamento: '',
        filter: {},
        selectedEntity: "",
        entity_options: '',
        leventoOption: '',
        filterCheckbox: {},
        filterChips: [],
        showFilter: false
      })
    }
    if (this.props.clickLimparFilter && (this.props.clickLimparFilter !== prevProps.clickLimparFilter)) {
      this.clearFilter();
    }
  }

  updateCheckButton = (modulename) => {
    let filter = { ...this.state.filter }
    let filterCheckbox = { ...this.state.filterCheckbox }
    this.props.filters &&
      this.props.filters.checkbox.map(_ck => {
        if (_ck.key !== modulename) {
          delete filter[_ck.key]
          delete filterCheckbox[_ck.key]
        }
      })
    this.setState({
      deafault_selected_checkbox: modulename,
      selectedEntity: "",
      filter: filter,
      filterCheckbox: filterCheckbox
    }, () => this.showFilter())
  }

  entityOptions() {
    let entlist = [...this.state.entityList];
    let entity_options = entlist.map((_r, i) => (
      <Option value={ _r.nif } key={ i }>{ _r.nome }<br />{ _r.nifap } </Option>
    ))
    this.setState({
      entity_options: entity_options
    })
  }

  levantoOptions = () => {
    let entlist = [...this.state.entityList];
    let leventoOption = entlist.map((_r, i) => (
      <Option value={ this.props.typeFilter === 'nif' ? _r.nif : _r.nrvitic } key={ i }>{ _r.nif }<br />{ _r.nrvitic } </Option>
    ))
    this.setState({
      leventoOption: leventoOption
    })
  }

  clearFilter = () => {
    this.setState({
      filter: {},
      selectedEntity: "",
      entity_options: '',
      leventoOption: '',
      filterCheckbox: {}
    }, () => {
      this.showFilter()
      this.handleSearch()
      clicksarch()
      clearsearchfilterInputdiv()
    })
  }


  handleEntitySelect = (value) => {
    let filter = { ...this.state.filter };
    let filterCheckbox = { ...this.state.filterCheckbox }
    let row = this.state.entity_list_object[value] ? this.state.entity_list_object[value] : {};

    if (this.props.filters.checkbox.length > 0) {

      if (row.nome) {
        filter[this.state.deafault_selected_checkbox] = row.nome;
        filterCheckbox[this.state.deafault_selected_checkbox] = row.nif
      } else {
        filter[this.state.deafault_selected_checkbox] = "";
        filterCheckbox[this.state.deafault_selected_checkbox] = ""
      }
    } else {
      filter['entity'] = row.nome;
      if (this.props.filterFor === "Rotulo") {
        filterCheckbox["entityId"] = row.codEntidade
      }
      else {
        filterCheckbox["entity_id"] = row.nifap
      }
    }

    this.setState({
      filter,
      filterCheckbox,
      selectedEntity: value,
      popUpEntity: value
    }, () => {
      this.showFilter();
    })
  }
  handleKeyDownNumber = (value) => {
   console.log(value.currentTarget.value)
   $("#KeyDownId").val(value.currentTarget.value.toUpperCase())
    var digits = value.currentTarget.value.toString().split('');
    var realDigits = digits.map(Number)
    console.log(realDigits);
    if(value.currentTarget.value.length < 3 || value.currentTarget.value.length == 4){
      var isNumber = this.containsNumber(value.currentTarget.value.substring(value.currentTarget.value.length-1))
      if(isNumber == true){
        $("#KeyDownId").val(value.currentTarget.value.substring(0, value.currentTarget.value.length-1).toUpperCase())
      }
    }else if(value.currentTarget.value.length == 6){
      var isNumber = this.containsNumber(value.currentTarget.value.substring(value.currentTarget.value.length-1))
        var a = value.currentTarget.value;
        var b = "-";
        var position = 5;
        var output = [a.slice(0, position), b, a.slice(position)].join('');
        console.log(output);
        $("#KeyDownId").val(output)
      if(isNumber == false){
       
        $("#KeyDownId").val(value.currentTarget.value.substring(0, value.currentTarget.value.length-1))
      }

    }else if(value.currentTarget.value.length == 14){
      $("#KeyDownId").val(value.currentTarget.value.substring(0, value.currentTarget.value.length-1))
    }else if(value.currentTarget.value.length == 3 || value.currentTarget.value.length == 5 || value.currentTarget.value.length > 5){
      var isNumber = this.containsNumber(value.currentTarget.value.substring(value.currentTarget.value.length-1))
      if(isNumber == false){
        $("#KeyDownId").val(value.currentTarget.value.substring(0, value.currentTarget.value.length-1))
      }
    }
   
  }
  containsNumber(str) {
    return /\d/.test(str);
  }
  handleLevantoSelect = (value) => {
    let filter = this.state.filter;
    delete filter['nif']
    delete filter['nrvitic']
    filter[this.props.typeFilter] = value;
    this.setState({
      filter,
      leventoOption: ''
    }, () => {
      this.showFilter();
    })
  }

  handelDateRangeFilter(key, e) {
    let filter = { ...this.state.filter };
    //console.log("key",key)
    if (e) {
      const startKeyName = (() => {
        if (key === 'RangePickerVinicaCreation') {
          return 'DataCriadoStart';
        } else if (key === 'RangePickerVinicaModification') {
          return 'DataModificadoStart';
        } else if (key === 'dataApos') {
          return 'startDateAposicao';
        } else if (key === 'dataEng') {
          return 'startDateEngarrafamento';
        } else if (key === 'Last Login Date') {
          return 'data inicial de login';
        }else if(key==="operationDate"){
          return 'DataOperaçãoStart'
        } else {
          return 'start_date';
        }
      })();

      const endKeyName = (() => {
        if (key === 'RangePickerVinicaCreation') {
          return 'DataCriadoEnd';
        } else if (key === 'RangePickerVinicaModification') {
          return 'DataModificadoEnd';
        } else if (key === 'dataApos') {
          return 'endDateAposicao';
        } else if (key === 'dataEng') {
          return 'endDateEngarrafamento';
        } else if (key === 'Last Login Date') {
          return 'data final de login';
        }else if (key==="operationDate"){
          return 'DataOperaçãoEnd'
        } else {
          return 'end_date';
        }
      })();

      filter[startKeyName] = moment(e.value.start).isValid() ? moment(e.value.start).format("YYYY-MM-DD") : null
      filter[endKeyName] = moment(e.value.end).isValid() ? moment(e.value.end).format("YYYY-MM-DD") : null
      //console.log("update filter in handle filter", filter)
      this.setState({
        filter,
      }, () => this.showFilter())
    }
  }

  handleInputChange = (key, e, name) => {
    let cod = {}
    //console.log("e.taregt valuee",e.target)
    //console.log("key and eeeeeeeee",e)
    let filter = { ...this.state.filter };
    if (key === "RangePicker" || key === 'RangePickerVinicaCreation' || key === 'RangePickerVinicaModification' || key==="dataApos" || key==="dataEng" || key==="Last Login Date" || key==="operationDate") {
      //console.log("Eeeeeeeeeeeeeeeeeeeeeeeeeee",e.value)
      this.handelDateRangeFilter(key, e);
      return
    }
    // console.log("affterr handle date range filter")
    let value = ""
    if (e) {
      value = (e._d && moment(e._d).isValid()) ? moment(e._d).format("YYYY-MM-DD") : (e.target.value || '')
      filter[key] = value
      if(key === "Distrito") {
        cod[key] = name
      }
      else if(key === "Concelho") {
        cod[key] = name
      }
      else if(key === "Freguesia") {
        cod[key] = name
      }
    } else {
      delete filter[key]
    }

    if(key === 'Distrito'){
      delete filter['Concelho']
      delete filter['Freguesia']
    }else if(key === 'Concelho'){
      delete filter['Freguesia']
    }

    this.setState({
      filter,
      cod: {...this.state.cod, ...cod}
    }, () => {
      this.showFilter()
    })
  }

  removefilter = (key) => {
    //console.log("the ket removed is ", key)
    let filter = { ...this.state.filter };
    let filterCheckbox = { ...this.state.filterCheckbox };
    // filter[key] = ''
    if (key === "entity") {
      if (this.props.filterFor === "Rotulo") {
        delete filterCheckbox["entityId"]
      }
      else {
        delete filterCheckbox["entity_id"]
      }
    }
    if(key === "InstallationNo") {
      delete filter["Installation"]
    }
    delete filter[key]
    delete filterCheckbox[key]
    this.setState({
      filter,
      selectedEntity: "",
      filterCheckbox,
      entity_options: '',
      leventoOption: ''
    }, () => {

      this.showFilter();
      clearsearchfilterInputdiv()
      // this.handleSearch();
    }

    )
  }

  showFilter = () => {
    let filterChips = Object.keys(this.state.filter).map((_k, i) => {
        if (this.state.filter[_k] && _k !== 'entityIdFilter' && _k !== 'Installation') {
            //console.log("_k is ", _k)
            return (
                <span key={ i } className="chips position-relative">
                
                <span>
                { Lang.langCheck.langRequest((_k === "geocod" && this.props.typeFilter) ? "Código direito" : (_k === "numeroRegistoHist") ? "Número de Registo Histórico" : (_k === "anoProduto") ? "Ano do Produto" : (_k === "mencaoObrigatoria") ? "Menção Qualitativa" :
                (_k === "numeroRegisto") ? "Número de Registo" : (_k === "NomeEntreposto") ? "Entreposto" : _k === "Designacao" ? "Designação" : _k === "OwnerName" ? "Nome da entidade" : _k === "orderno" ? "Número de Pedido" : _k === "InstallationName" ? "Nome da instalação" : _k === "start_date" ? "Data de Pedido de" : _k === "end_date" ? "Data de Pedido a" : _k) } 
                : {" "}
                { (_k === "Distrito" ||
                _k === "Concelho" ||
                _k === "Freguesia") ? this.state.cod[_k] : this.state.filter[_k] }</span>
                
                {/* {
                (_k !== "Distrito" &&
                _k !== "Concelho" &&
                _k !== "Freguesia") &&
                
                } */}
                
                <span onClick={ () => this.removefilter(_k) } className="close-key cursor-pointer"><i className="fas fa-times-circle" title="Remover Filtro"></i></span>
                </span>
            );
            
        }else{
            return []
          }
    });

    this.setState({
      filterChips,
      selectedEntity: "",
      levantamento: ''
    })
  }

  handleShowFilter = () => {
    this.setState({
      showFilter: this.state.showFilter ? false : true
    })
  }

  handleCheckboxParcelFilter = (row, key) => {
    let filterCheckbox = { ...this.state.filterCheckbox }
    let cond = false
    if ((key === 'Explorer' || key === 'Explorer/Owner') && filterCheckbox[key]) {
      let parcelExplorer = row['parcelExplorer']
      if (parcelExplorer) {
        parcelExplorer.map((_row) => {
          if (_row.entityId === filterCheckbox[key]) {
            cond = true;
          }
        })
      }

    }
    if ((key === 'Owner' || key === 'Explorer/Owner') && filterCheckbox[key]) {
      let parcelProperty = row['parcelProperty']
      if (parcelProperty) {
        parcelProperty.map((_row) => {
          if (_row.entityId === filterCheckbox[key]) {
            cond = true;
          }
        })
      }

    }
    return cond;
  }

  applyFilter = (row) => {
    let cond = true
    return false;
  }
  handleSearchNumeroSelo= () => {
        if($("#KeyDownId").val().length ==13){
      this.handleSearch()
    }
   
  }
  handleSearch = () => {
    let data = [];
    let cond = false
    let filterData = this.props.data
    Object.keys(this.state.filter).map(_k => {
      if(_k === 'entityId' && isNaN(+this.state.filter[_k])){
        cond = true
        return
      }
    })
    if(cond){
      toast.error('Os dados utilizados são inválidos.')
      return
    }
    if (Object.keys(this.state.filter).length === 0) {
      this.props.handleFilter(filterData)
    }
    else if (this.props && filterData) {
      filterData.map((_r) => {
        this.applyFilter(_r) &&
          data.push(_r)
      })
      if (this.props.handleFilter) {
        this.props.handleFilter(data)
      }
    }

    if (this.props.getFilter) {
      this.returnFilter()
    }
  }

  returnFilter = () => {
    let filters = {
      "filters": { ...this.state.filter },
      "filterCheckbox": { ...this.state.filterCheckbox }
    }
    this.props.getFilter(filters);
  }

  /*  Para fechar pop-up  */

  closePopup = () => {
    $(".left-popup").trigger('click');
  }



  onSearch = async (e) => {
    if (e.length >= 3) {
      let res = await services.EntityList.getEntityList('parcel', e);
      if (res) {
        this.setState({
          entityList: res.entityList,
          entity_list_object: res.entity_row,
          searchValid: e.length
        }, () => this.entityOptions())
      }
    } else {
      this.setState({
        searchValid: 0,
        entity_options: ''
      })
    }
  }

  onLeventoSearch = async (e) => {
    if (e.length >= 3) {
      let data = {
        "Filters": {
          "nif": null,
          "nrvitic": null
        },
        "SortBy": "nif",
        "IsSortTypeDESC": true,
        "IsPagination": true,
        "Page": 1,
        "PageSize": 20
      }
      data["Filters"][this.props.typeFilter] = +e
      let res = await services.apiCall.requestApi('/Levantamento/GetDetail', data, 'post');
      if (res) {
        this.setState({
          entityList: res,
          searchValid: e.length
        }, () => this.levantoOptions())
      }
    } else {
      this.setState({
        searchValid: 0,
        leventoOption: ''
      })
    }
  }
 
  handleInstallationNumberSearch = async (value) => {
    console.log("AQUI")
    if (value.length) {
      //console.log("the value is ", value)
      //console.log("this.props.moduleType: ", this.props.moduleType);
      let requestBody = {
          Filters: null,
          SortBy: '',
          IsSortTypeDESC: true,
          IsPagination: false,
          Page: 2,
          PageSize: 2,
          isConta:0
      }

      if(this.props.moduleType === 'Conta'){
        requestBody['isConta'] = 1
        
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      }
      else if(this.props.moduleType === 'SelosRequisiçãoPendentes'){
        requestBody['isConta'] = 1
        requestBody['isGrafica'] = true
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      }else if(this.props.moduleType === 'SelosRastreabilidade'){
        requestBody['isConta'] = 1
       
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      }
       else if (this.props.moduleType === 'Receita'){
        requestBody['isConta'] = 1
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      } else if (this.props.moduleType === 'FiscalizacaoInsercaoSelosEtiquetas'){
        requestBody['isConta'] = 1
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      }else if (this.props.moduleType === 'InserirFatura'){
        requestBody['isConta'] = 1
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      } else if(this.props.moduleType === 'TableIV'){// Marco até 537 referênte Instalação Vinica
        requestBody['isConta'] = 0
        if( !isNaN(+value)){
          requestBody['search'] = value
          requestBody['searchKey'] = ''
        }else{
          requestBody['searchKey'] = value
          requestBody['search'] = ''
        }
      }else{
        requestBody['search'] = value
        //console.log("the request body is ", requestBody)
      }
      var res;
      if(this.props.moduleType === 'Receita'){
        requestBody = {Nome : requestBody.searchKey}
         res = await services.apiCall.requestApi('/Entidades/ViewEntidadesFiscalizacao',requestBody , 'get');
      }else{
       
         res = await services.apiCall.requestApi('/InstalacaoVinica/GetInstalacaoFromNumberOrDesignation',requestBody , 'post');
      }
      
      //console.log('res:- ', res);
      if (res && res.length) {
        this.setState({ 
            searchValid: value.length
        });
        if(this.props.moduleType === 'Conta') {
            let contaSearchByOwner = true
            if(!isNaN(requestBody['search'])) {
              //console.log("2211 request body ", requestBody)
              contaSearchByOwner = true
            }
            if(requestBody["searchKey"]) {
              contaSearchByOwner = true
            }
            this.setState({
                contaOwners : res,
                contaSearchByOwner
            })
        }
        if(this.props.moduleType === 'SelosRequisiçãoPendentes') {
          let contaSearchByOwner = true
          if(!isNaN(requestBody['search'])) {
            //console.log("2211 request body ", requestBody)
            contaSearchByOwner = true
          }
          if(requestBody["searchKey"]) {
            contaSearchByOwner = true
          }
          this.setState({
              contaOwners : res,
              contaSearchByOwner
          })
      }
      if(this.props.moduleType === 'SelosRastreabilidade') {
        let contaSearchByOwner = true
        if(!isNaN(requestBody['search'])) {
          //console.log("2211 request body ", requestBody)
          contaSearchByOwner = true
        }
        if(requestBody["searchKey"]) {
          contaSearchByOwner = true
        }
        this.setState({
            contaOwners : res,
            contaSearchByOwner
        })
    }
        if(this.props.moduleType === 'Receita') {
          let contaSearchByOwner = true
          if(!isNaN(requestBody['search'])) {
            //console.log("2211 request body ", requestBody)
            contaSearchByOwner = true
          }
          if(requestBody["Nome"]) {
            contaSearchByOwner = true
          }
          this.setState({
              contaOwners : res,
              contaSearchByOwner
          })
        }
        if(this.props.moduleType === 'FiscalizacaoInsercaoSelosEtiquetas') {
          let contaSearchByOwner = true
          if(!isNaN(requestBody['search'])) {
            //console.log("2211 request body ", requestBody)
            contaSearchByOwner = true
          }
          if(requestBody["searchKey"]) {
            contaSearchByOwner = true
          }
          this.setState({
              contaOwners : res,
              contaSearchByOwner
          })
        }
        if(this.props.moduleType === 'InserirFatura') {
          let contaSearchByOwner = true
          if(!isNaN(requestBody['search'])) {
            //console.log("2211 request body ", requestBody)
            contaSearchByOwner = true
          }
          if(requestBody["searchKey"]) {
            contaSearchByOwner = true
          }
          this.setState({
            contaOwners : res,
            contaSearchByOwner
          })
      }
      if ( this.props.moduleType === 'TableIV'){ //Marco até 594 referênte Instalação Vinica
        let contaSearchByOwner = true
        if (!isNaN(requestBody['searh'])){
          //console.log("2211 request body ", requestBody)
          contaSearchByOwner = true
        }
        if(requestBody["searchKey"]){
          contaSearchByOwner = true
        }
        this.setState({
          contaOwners : res,
          contaSearchByOwner
          
          
        })
      }
        const installationOptions = res.map((item, index) => (
          this.props.moduleType === 'Conta' ||  this.props.moduleType === 'SelosRequisiçãoPendentes' || this.props.moduleType === 'SelosRastreabilidade'?
          (
            // requestBody['search'] && !isNaN(requestBody['search']) ?
            // (
            //     <Option value={item.nif+'-'+item.ownername+'-'+item.designacao } key={index}>
            //     { item.ownername } <br /> 
            //     { item.nif }
            //     </Option >
            // )
            // :
            // (
            //     <Option value={item.nif+'-'+item.idInstalacaoVinica+'-'+item.designacao } key={ item.idInstalacaoVinica }>
            //     {item.designacao}<br />{item.ownername ? (item.ownername) : ""} - { item.nif }
            //     </Option >
            // )
            <Option value={item.nif+'-'+item.ownername+'-'+item.designacao } key={index}>
            { item.ownername } <br /> 
                { item.nif }
               </Option >
            
          )
          :
          (
            this.props.moduleType === 'Receita'?
            <Option value={item.nif + "-"+ item.codEntidade + "-" + item.nome} key={index}>
              { item.nome } - {item.nif} 
              
            </Option >:
            !isNaN(requestBody['search']) ? 
            <Option value={item.nif} key={index}>
              { item.ownername } - {item.nif} 
            </Option >
            :
            
             
            <Option value={item.designacao} key={index}>
              { item.designacao} - { item.ownername } - {item.nif} 
              
            </Option >
           
          )
          
        ))
        
        this.setState({ installationOptions }, () => {
          //console.log("installation options ", this.state.installationOptions)
        })
      }
    } else {
      this.setState({ searchValid: 0, installationOptions: '' })
    }
  }

  handleInstallationNumberSelect = (value) => {
      //console.log("000 handle Install select", value)
    const filter = this.state.filter;
    if(this.props.moduleType === 'Conta'){
        if(this.state.contaSearchByOwner) {
            //console.log("000 cond 1", this.state.contaOwners)
            let nif = value.split('-')[0]
            let targetOwner = []
            let owners = [...this.state.contaOwners]
            if(Array.isArray(owners) && owners.length > 0) {
                //console.log("000 if statement")
                targetOwner = owners.filter(owner => {
                    if(nif === owner.nif) return true
                    else return false
                })
            }
            //console.log("000 target owner ", targetOwner)
            if(targetOwner.length > 0) {
                let owner = targetOwner[0]
                filter.entityIdFilter = owner.nif
                filter.Installation = owner.designacao
                filter.OwnerName = owner.ownername
                //console.log("000 filter", filter)
            }
        }
        else {
            filter.entityIdFilter = value.split('-')[0]
            filter.Installation = value.split('-')[1]
            filter.InstallationName = value.split('-')[2]
        }
        
     } else if(this.props.moduleType === 'SelosRequisiçãoPendentes'){
      if(this.state.contaSearchByOwner) {
          //console.log("000 cond 1", this.state.contaOwners)
          let nif = value.split('-')[0]
          let targetOwner = []
          let owners = [...this.state.contaOwners]
          if(Array.isArray(owners) && owners.length > 0) {
              //console.log("000 if statement")
              targetOwner = owners.filter(owner => {
                  if(nif === owner.nif) return true
                  else return false
              })
          }
          //console.log("000 target owner ", targetOwner)
          if(targetOwner.length > 0) {
              let owner = targetOwner[0]
              filter.entityIdFilter = owner.nif
              filter.Installation = owner.designacao
              filter.OwnerName = owner.ownername
              //console.log("000 filter", filter)
          }
      }
      else {
          filter.entityIdFilter = value.split('-')[0]
          filter.Installation = value.split('-')[1]
          filter.InstallationName = value.split('-')[2]
      }
      
  } else if(this.props.moduleType === 'SelosRastreabilidade'){
    if(this.state.contaSearchByOwner) {
        //console.log("000 cond 1", this.state.contaOwners)
        let nif = value.split('-')[0]
        let targetOwner = []
        let owners = [...this.state.contaOwners]
        if(Array.isArray(owners) && owners.length > 0) {
            //console.log("000 if statement")
            targetOwner = owners.filter(owner => {
                if(nif === owner.nif) return true
                else return false
            })
        }
        //console.log("000 target owner ", targetOwner)
        if(targetOwner.length > 0) {
            let owner = targetOwner[0]
            filter.entityIdFilter = owner.nif
            filter.Installation = owner.designacao
            filter.OwnerName = owner.ownername
            //console.log("000 filter", filter)
        }
    }
    else {
        filter.entityIdFilter = value.split('-')[0]
        filter.Installation = value.split('-')[1]
        filter.InstallationName = value.split('-')[2]
    }
    
}else if(this.props.moduleType === 'InserirFatura'){
        if(this.state.contaSearchByOwner) {
            //console.log("000 cond 1", this.state.contaOwners)
            let nif = value.split('-')[0]
            let targetOwner = []
            let owners = [...this.state.contaOwners]
            if(Array.isArray(owners) && owners.length > 0) {
                //console.log("000 if statement")
                targetOwner = owners.filter(owner => {
                    if(nif === owner.nif) return true
                    else return false
                })
            }
            //console.log("000 target owner ", targetOwner)
            if(targetOwner.length > 0) {
                let owner = targetOwner[0]
                filter.entityIdFilter = targetOwner[0].codEntidade
                filter.OwnerName = targetOwner[0].ownername
            }
        }
        else {
            filter.entityIdFilter = value.split('-')[0]
            filter.Installation = value.split('-')[1]
            filter.InstallationName = value.split('-')[2]
        }

    }else if(this.props.moduleType === 'Receita'){
      if(this.state.contaSearchByOwner) {
          //console.log("000 cond 1", this.state.contaOwners)
          let nif = value.split('-')[0]
          let targetOwner = []
          let owners = [...this.state.contaOwners]
          if(Array.isArray(owners) && owners.length > 0) {
              //console.log("000 if statement")
              targetOwner = owners.filter(owner => {
                  if(nif === owner.nif) return true
                  else return false
              })
          }
          //console.log("000 target owner ", targetOwner)
          if(targetOwner.length > 0) {
            //item.nif + "-"+ item.codEntidade + "-" + item.nome
              let owner = targetOwner[0]
              filter.entityIdFilter = value.split('-')[1]
              filter.OwnerName = value.split('-')[2]
          }
      }
      else {
          filter.entityIdFilter = value.split('-')[0]
          filter.Installation = value.split('-')[1]
          filter.InstallationName = value.split('-')[2]
      }
    }else if(this.props.moduleType === 'FiscalizacaoInsercaoSelosEtiquetas'){
      if(this.state.contaSearchByOwner) {
          //console.log("000 cond 1", this.state.contaOwners)
          let nif = value.split('-')[0]
          let targetOwner = []
          let owners = [...this.state.contaOwners]
          if(Array.isArray(owners) && owners.length > 0) {
              //console.log("000 if statement")
              targetOwner = owners.filter(owner => {
                  if(nif === owner.nif) return true
                  else return false
              })
          }
          //console.log("000 target owner ", targetOwner)
          if(targetOwner.length > 0) {
              let owner = targetOwner[0]
              filter.entityIdFilter = targetOwner[0].codEntidade
              filter.OwnerName = targetOwner[0].ownername
          }
      }
      else {
          filter.entityIdFilter = value.split('-')[0]
          filter.Installation = value.split('-')[1]
          filter.InstallationName = value.split('-')[2]
      }
    }else if(this.props.moduleType === 'TableIV'){ // Marco até 759, referênte há Instalação Vínica
        if(this.state.contaSearchByOwner) {
            //console.log("000 cond 1", this.state.contaOwners)
            let nif = value.split('-')[0]
            let targetOwner = []
            let owners = [...this.state.contaOwners]
            if(Array.isArray(owners) && owners.length > 0) {
                //console.log("000 if statement")
                targetOwner = owners.filter(owner => {
                    if(nif === owner.nif) return true
                    else return false
                })
            }
            //console.log("000 target owner ", targetOwner)
            if(targetOwner.length > 0) {
                let owner = targetOwner[0]
                filter.entityIdFilter = owner.nif
                filter.Installation = owner.designacao
                filter.OwnerName = owner.ownername
                //console.log("000 filter", filter)
            }
        }
        else {
            filter.entityIdFilter = value.split('-')[0]
            filter.Installation = value.split('-')[1]
            filter.InstallationName = value.split('-')[2]
        }
  }
    
    else{
      if(!isNaN(value)){
        filter.Installation = value
        filter.InstallationNo = value
        
      }
      else if(isNaN(value)){
        filter.Designacao = value
        filter.InstallationNo = null
        filter.Installation = null
      }
      
    }
    
    this.setState({
      filter,
      installationOptions: ''
    }, () => {
      this.showFilter();
    })
  }

  handleBoletimNumberSearch = async (value) => {
    if (value.length) {
      let requestBody = {
          Filters: null,
          SortBy: '',
          IsSortTypeDESC: true,
          IsPagination: false,
          Page: 2,
          PageSize: 2,
          NumBoletim : +value
      }

      const res = await services.apiCall.requestApi('/boletim/getboletim',requestBody , 'post');
      //console.log('res:- ', res);
      if (res && res.length) {
        this.setState({ searchValid: value.length });
        const boletimOptions = res.map((item, index) => (
          <Option value={item.numBoletim } key={ item.numBoletim }>
            { item.designacao } <br /> { item.numBoletim }
          </Option >
        ))
        this.setState({ boletimOptions })
      }
    } else {
      this.setState({ searchValid: 0, boletimOptions: '' })
    }
  }

  handleBoletimNumberSelect = (value) => {
    const filter = this.state.filter;
    filter.numero = +value
    // filter.BoletimName = value.split('-')[1]
    this.setState({
      filter,
      boletimOptions: ''
    }, () => {
      this.showFilter();
    })
  }
  handleRegistoNumberSelect = (value) => {
    const filter = this.state.filter;
    filter.numeroRegisto = value;
    this.setState({
      filter,
      RegistoOptions: []
    }, () => {
      this.showFilter();
    })
  }
  // ----> handleEstatutoSelect
  handleEstatutoSelect = (value) => {
    const filter = this.state.filter;
    filter.estatuto = value
    // filter.BoletimName = value.split('-')[1]
    this.setState({
      filter,
      estatutoOptions: ''
    }, () => {
      this.showFilter();
    })
  }

  // --->handleEstatutoSearch
  handleEstatutoSearch = async (value) => {
    if (value.length) {
      let requestBody = {
        "Filters": null,
        "SortBy": "",
        "IsSortTypeDESC": true,
        "IsPagination": false,
        "Page": 2,
        "PageSize": 2,
        "Estatuto": value
      }

      const res = await services.apiCall.requestApi('/Estatuto/GetEstatutoName',requestBody , 'post');
      //console.log('res:- ', res);
      if (res && res.length) {
        this.setState({ searchValid: value.length });
        const estatutoOptions = res.map((item, index) => (
          <Option value={item.description } key={ item.codEstatuto }>
            { item.description }
          </Option >
        ))
        this.setState({ estatutoOptions })
      }
    } else {
      this.setState({ searchValid: 0, estatutoOptions: '' })
    }
  }
  
  // ---> handleSelosNumberSelect
  handleSelosNumberSelect = (value) => {
    const filter = this.state.filter;
    filter.orderno = value.toString()
    // filter.BoletimName = value.split('-')[1]
    this.setState({
      filter,
      SelosOptions: ''
    }, () => {
      this.showFilter();
    })
  }

  handleMarcasNumberSelect=(value)=>{
    const filter = this.state.filter;
    filter["Nº Processo"] = value.toString()
    // filter.BoletimName = value.split('-')[1]
    this.setState({
      filter,
      SelosOptions: ''
    }, () => {
      this.showFilter();
    })
  }

  // --->handleSelosNumberSearch
  handleSelosNumberSearch = async (value) => {
    if (value.length) {
      let requestBody = {
        "Filters": null,
        "SortBy": "",
        "IsSortTypeDESC": true,
        "IsPagination": false,
        "Page": 2,
        "PageSize": 2,
        "Estado": (this.props.parsed && this.props.parsed.name && this.props.parsed.name.slice(0,-1)) || "",
        "orderNo": +value
      }

      const res = await services.apiCall.requestApi('/Sales/GetOrderNumber',requestBody , 'post');
      //console.log('res:- ', res);
      if (res && res.length) {
        this.setState({ searchValid: value.length });
        const SelosOptions = res.map((item, index) => (
          <Option value={item.codRegistoSelo } key={ index }>
            { item.codRegistoSelo }
          </Option >
        ))
        this.setState({ SelosOptions })
      }
    } else {
      this.setState({ searchValid: 0, SelosOptions: '' })
    }
  }

  handleRegistoNumberSearch = async (value) => {
    if (value.length > 0) {
      //console.log("REGISTO VALUE:", value)
      let requestBody = {
          Filters: {numeroRegisto: value},
          SortBy: 'numeroRegisto',
          IsSortTypeDESC: true,
          IsPagination: false,
          Page: 2,
          PageSize: 2
        }
      const response = await services.apiCall.requestApi("/Registo/GetDetail",requestBody, "post");
      //console.log("response REGISTO", response)
      if(response && response.length){
        const RegistoOptions = response.map((item, index) => (
          <Option value={item.numeroRegisto } key={ index }>
          Número de registo:{item.numeroRegisto }<br />{ item.produto }-{item.anoProduto}
          </Option >
        ))
        this.setState({ RegistoOptions })
      }else{
        this.setState({ RegistoOptions: '',})
      }
    } else {
    this.setState({ searchValid: 0, RegistoOptions: '' })
  }

  }
  handleMarcasNumberSearch= async( value)=>{
    //console.log("value 800",value)
    const {tableName} = this.props;
    if(value.length){
      let estado=""
      if(tableName==="MarcasApproved"){
        estado="approved"
      }else if(tableName==="MarcasPendentes"){
        estado="pending"
      }else if(tableName==="MarcasHistory"){
        estado="history"
      }
      let requestBody ={
        filters: {
          status: estado,
          processNumber: +value,
          brandCode: -1,
          brandName: null,
          entidadeNIF: null,
          entidadeName: null,
          brandValidFromDate: null,
          brandValidToDate: null,
      },
      isPagination: true,
      isSortTypeDESC: true,
      page: 0,
      pageSize: 0,
      sortBy: null,
      }
      const response = await services.apiCall.requestApi("/Marcas/GetMarcaList",requestBody, "post");
      //console.log("response 800", response)
      if(response && response.length){
        // this.setState({ searchValid: value.length });
        const MarcasOptions = response.map((item, index) => (
          <Option value={item.idMarcaRequest } key={ index }>
           { item.idMarcaRequest }-{item.marca}
          </Option >
        ))
        this.setState({ MarcasOptions })
      }else{
        this.setState({ MarcasOptions: ''})
      }
    }

  }

  /*  Para renderizar o conteúdo html da página   */

  render() {
    let entity = this.state.filter.entity;
    if (this.state.filter.Explorer)
      entity = this.state.filter.Explorer;
    else if (this.state.filter.Owner)
      entity = this.state.filter.Owner;
    else if (this.state.filter["Explorer/Owner"])
      entity = this.state.filter["Explorer/Owner"];

    return (
      <div>
        <Tooltip anchorElement="target" position="top" color={ "#808080" }>

          <div className={ "search-section d-md-flex mt-2" }>
            <div className={ this.props.typeFilter ? "text-area aplicar-search d-sm-flex align-items-center searh-text-area pt-0 pb-0 width_82" : "text-area aplicar-search d-sm-flex align-items-center searh-text-area pt-0 pb-0" }>
              {/* <div className="input-img"> <i className="fas fa-search mr-1" aria-hidden="true"></i></div>  */
              }
              {
                !this.props.typeFilter &&
                <div className="input-img"><span className="k-icon k-i-zoom"></span></div>
              }
              <div className="w-100 align-items-center search-left position-relative dashboard-search">
                {
                  this.state.filterChips.length > 0 ? this.state.filterChips
                    : <span></span>

                }
                {
                  this.props.showEntity && !entity &&
                  <Select
                    id="parcelEntityFilter"
                    className="parcelEntityFilter"
                    style={ { marginTop: "4px" } }
                    dropdownStyle={ { zIndex: "0" } }
                    onChange={ this.handleEntitySelect }
                    value={ this.state.selectedEntity }
                    showSearch
                    onSearch={ this.onSearch }
                    maxTagTextLength={ 3 }
                    placeholder={ this.props.searchplaceholder || "Pesquisa por Nome ou Nº de Entidade"}
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>{ Lang.langCheck.langRequest(this.props.searchplaceholder || "Pesquisa por Nome ou Nº de Entidade") }</Option>
                    {
                      // this.state.searchValid >= 3 &&
                      this.state.entity_options
                    }
                  </Select>
                }
                {
                  this.props.typeFilter &&
                  <Select
                    style={ { marginTop: "4px" } }
                    onChange={ this.handleLevantoSelect }
                    value={ this.state.levantamento || '' }
                    showSearch
                    onSearch={ this.onLeventoSearch }
                    maxTagTextLength={ 3 }
                    placeholder={ this.props.typeFilter === 'nif' ? "Pesquisa por NIF" : "Pesquisa por Nº Viticultor" }
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>{ this.props.typeFilter === 'nif' ? "Pesquisa por NIF" : "Pesquisa por Nº Viticultor" }</Option>
                    {
                      this.state.leventoOption
                    }
                  </Select>
                }
                {
                  this.props.installationNumber &&
                  <Select
                    style={ { marginTop: "4px" } }
                    onChange={ this.handleInstallationNumberSelect }
                    value={ this.state.levantamento || '' } // TODO: Change the state for value
                    showSearch
                    onSearch={ this.handleInstallationNumberSearch }
                    maxTagTextLength={ 3 }
                    //placeholder={this.props.searchplaceholder}
                    placeholder={ this.props.searchplaceholder || "Pesquisa por NIF ou designação"}
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>Pesquisa por NIF ou designação</Option>
                    { this.state.installationOptions }
                  </Select>
                }
                {
                  this.props.installationNumberTest &&
                  <Input
                    style={ {border: "none" , width:"100%" , boxShadow: "none"} }
                    // onChange={ this.handleInstallationNumberSelect }
                    //value={ this.state.levantamento || '' } // TODO: Change the state for value
                    showSearch
                    onInput={this.handleKeyDownNumber}
                    //onKeyDown = {this.handleKeyDownNumber}
                    
                    id="KeyDownId"
                    //placeholder={this.props.searchplaceholder}
                    placeholder={ this.props.searchplaceholder || "Pesquisa por Número de Selo"}
                    optionFilterProp="children"
                    notFoundContent="Selo não encontrado, refina os critérios de pesquisa"
                  />
                }
                {
                  this.props.showBoletim && !this.state.filter.numBoletim &&
                  <Select
                    style={ { marginTop: "4px" } }
                    onChange={ this.handleBoletimNumberSelect }
                    value={ this.state.levantamento || '' } // TODO: Change the state for value
                    showSearch
                    onSearch={ this.handleBoletimNumberSearch }
                    maxTagTextLength={ 3 }
                    placeholder="Pesquisa por Nº de Boletim"
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>Pesquisa por Nº de Boletim</Option>
                    { this.state.boletimOptions }
                  </Select>
                }
                {
                  this.props.showSelosSearch && !this.state.filter.orderno &&
                  <Select
                    style={ { marginTop: "4px" } }
                    onChange={ this.handleSelosNumberSelect }
                    value={ this.state.levantamento || '' } // TODO: Change the state for value
                    showSearch
                    onSearch={ this.handleSelosNumberSearch }
                    maxTagTextLength={ 3 }
                    placeholder={this.props.searchplaceholder}
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>{this.props.searchplaceholder}</Option>
                    { this.state.SelosOptions }
                  </Select>
                }
                {
                  this.props.showMarcasSearch && 
                  <Select
                  style={ { marginTop: "4px" } }
                  onChange={ this.handleMarcasNumberSelect }
                  value={ this.state.levantamento || '' } // TODO: Change the state for value
                  showSearch
                  onSearch={ this.handleMarcasNumberSearch }
                  maxTagTextLength={ 3 }
                  placeholder={this.props.searchplaceholder}
                  optionFilterProp="children"
                  notFoundContent="Processo não encontrado, redefina os critérios de pesquisa"
                >
                  <Option value="" disabled>{this.props.searchplaceholder}</Option>
                  { this.state.MarcasOptions.length> 0 ? this.state.MarcasOptions:null }
                </Select>
                }
                {
                  this.props.showEstatutoSearch && (!this.state.filter.moduleFiscalization || !this.state.filter.moduleHarvard || !this.state.filter.moduleParcel || !this.state.filter.moduloConvocatoria )&&
                  <Select
                    style={ { marginTop: "4px" } }
                    onChange={ this.handleEstatutoSelect }
                    value={ this.state.levantamento || '' } // TODO: Change the state for value
                    showSearch
                    onSearch={ this.handleEstatutoSearch }
                    maxTagTextLength={ 3 }
                    placeholder={this.props.searchplaceholder}
                    optionFilterProp="children"
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                  >
                    <Option value="" disabled>{this.props.searchplaceholder}</Option>
                    { this.state.estatutoOptions }
                  </Select>
                }
                {this.props.registoProdComponent && this.props.moduleType === 'Registo' &&
                   <Select
                   style={ { marginTop: "4px" } }
                   onChange={ this.handleRegistoNumberSelect }
                   value={ this.state.levantamento || '' } // TODO: Change the state for value
                   showSearch
                   onSearch={ this.handleRegistoNumberSearch }
                   maxTagTextLength={ 3 }
                   placeholder={this.props.searchplaceholder}
                   optionFilterProp="children"
                   notFoundContent="Produto não encontrado, refina os critérios de pesquisa"
                 >
                   <Option value="" disabled>{this.props.optionText} </Option>
                   { this.state.RegistoOptions }
                 </Select>
                }
                {
                  this.props.showSearchDisabled && !Object.keys(this.state.filter).length &&
                  <Select
                    style={ { marginTop: "4px" } }
                    showSearch
                    maxTagTextLength={ 3 }
                    placeholder={this.props.searchplaceholder}
                    optionFilterProp="children"
                    disabled
                  >
                  </Select>
                }
                
              </div>
            </div>
            {
                

              <div className={ "categories-section d-flex  align-items-center justify-content-between" }>
                {
                    !this.props.installationNumber === true &&
                  !this.props.hidefiltros && Object.keys(this.props.filters.Tabs).length > 0 &&
                  <span onClick={ this.handleShowFilter } className="normal-filter cursor-pointer">Filtros { this.state.showFilter ? <i className="fas fa-caret-down ml-2"></i> : <i className="fas fa-caret-up ml-2"></i> }</span>
                }
                {
                    !this.props.installationNumber === true &&
                  this.props.leftside ? "" :
                    <div>
                      {
                        this.state.filterChips.length > 0 &&
                        <span className="lompar-filter text-danger cursor-pointer" onClick={ this.clearFilter }>Limpar Filtros</span>
                      }
                    </div>
                }
                {this.props.installationNumberTest === true ? 
                  <Button className="mr-2 btn-ivdp-secondary" id="searchButton" onClick={ this.handleSearchNumeroSelo }><i className="fas fa-search mr-1 ml-1"></i> { "Pesquisar" } </Button>
                  :
                  <Button className="mr-2 btn-ivdp-secondary" id="searchButton" onClick={ this.handleSearch }><i className="fas fa-search mr-1 ml-1"></i> { "Pesquisar" } </Button>
                }
                
              </div>
            }

          </div>
          {
            !this.props.installationNumber === true &&
            this.state.showFilter &&
            <FilterInputs date={ new Date() }
              deafault_selected_checkbox={ this.state.deafault_selected_checkbox }
              filters={ this.props.filters }
              updateFilters={ this.state.filter }
              updateCheckButton={ (modulename) => this.updateCheckButton(modulename) }
              handleInputChange={ (key, value, name) => this.handleInputChange(key, value, name) }
            />
          }

          <div className="modal left-popup" id="left-detail-popup">
            <div className="modal-dialog modal-sm">
              {
                this.state.detailPopUp
              }
            </div>
          </div>
        </Tooltip>
      </div>

    )
  }
}

export default SearchFilter;
